<template>
  <div class="common-card">
    <div class="common-card__header" v-if="hasHeader">
      <div class="common-card__header__left">
        <span v-if="title" class="common-card__header-title">{{ title }}</span>
        <slot v-else name="header"></slot>
      </div>
      <div class="common-card__header__right">
        <slot name="header-ops"></slot>
      </div>
    </div>
    <div class="common-card__content">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CommonCard',
  props: {
    title: {
      type: String
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    hasHeader: {
      type: Boolean,
      default: true
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/styles/common.scss';

.common-card {
  background-color: white;
  border-radius: $home-card-border-radius;

  @extend .f-c;
  @extend .common-card-margin;
  @extend .common-card-padding;
  @extend .shadow-level-three;

  .common-card__header {
    margin-bottom: 10px;

    @extend .f-r-c-sb;

    .common-card__header__left {
      .common-card__header-title {
        font-size: $title-level-four;
        font-weight: bold;
      }
    }
  }

  .common-card__content {
    flex-grow: 1 !important;
  }
}
</style>
